import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "edit",
  "use": "edit-usage",
  "viewBox": "0 0 14 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 13\" id=\"edit\"><path d=\"M.473 13.005.85 9.847 7.57 3.13l.68 2.097 2.147.73-6.718 6.72-3.208.328zM8.303 2.45l.693 2.107 2.108.694 2.16-2.157L10.46.29z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol